import { create } from 'zustand';

/**
 * Guidelines v2 re-accept gate (SPEC_V4 §7). Existing users who accepted an
 * older version must re-accept before matching, invites or joining a pod.
 * `request()` opens the sheet; `wait()` resolves true once accepted, false if dismissed.
 */
interface GuidelinesGateState {
  open: boolean;
  waiters: ((ok: boolean) => void)[];
  request: () => void;
  wait: () => Promise<boolean>;
  settle: (ok: boolean) => void;
}

export const useGuidelinesGate = create<GuidelinesGateState>((set, get) => ({
  open: false,
  waiters: [],
  request: () => set({ open: true }),
  wait: () =>
    new Promise<boolean>((resolve) => {
      set({ open: true, waiters: [...get().waiters, resolve] });
    }),
  settle: (ok) => {
    const ws = get().waiters;
    set({ open: false, waiters: [] });
    ws.forEach((w) => w(ok));
  },
}));
